import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, onyx} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemText: {
    color: onyx,
  },
  loadingBoxNewOrderingEntities: {
    height: 20,
    width: 110,
  },
  loadingBoxQsbFqv: {
    height: 20,
    width: 120,
  },
  loadingBoxQsbOrderingEntities: {
    height: 20,
    width: 40,
  },
  loadingBoxDaysRemaining: {
    height: 20,
    width: 60,
  },
});
